// extracted by mini-css-extract-plugin
export default {"branch-item":"BranchItem_branch-item__UILDT","name":"BranchItem_name__neLID","score":"BranchItem_score__93eq4"};